// features/userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const UserSlice = createSlice({
  name: 'user',
  initialState: {
    user: null, // Initial state for userId
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload; // Set userId
    },
    clearUser: (state) => {
      state.user = null; // Clear userId (e.g., on logout)
    },
  },
});

export const { setUser, clearUser } = UserSlice.actions; // Export actions
export default UserSlice.reducer; // Export reducer
